export default [
    {
        path: "ip-lists",
        name: "iplists",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipList/IpList.vue"
            ),
        meta: {
            title: `Ip List`,
        },
    },
    {
        path: "add-ip",
        name: "addip",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipList/AddIp.vue"
            ),
        meta: {
            title: `Add Ip`,
        },
    },
    {
        path: "edit-ip/:id",
        name: "editip",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipList/EditIp.vue"
            ),
        meta: {
            title: `Edit Ip`,
        },
    },
    {
        path: "addon-category-lists",
        name: "addoncategorylist",
        component: () =>
            import(
                /* webpackChunkName: "addonCategoryList" */ "../pages/ipList/addonCategoryList.vue"
            ),
        meta: {
            title: `Addon Category List`,
        },
    },
    {
        path: "add-addon-category",
        name: "addaddoncategory",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipList/AddAddonCategory.vue"
            ),
        meta: {
            title: `Add Addon Category`,
        },
    },
    {
        path: "edit-addon-category/:id",
        name: "editaddoncategory",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipList/AddAddonCategory.vue"
            ),
        meta: {
            title: `Edit Addon Category`,
        },
    },
];
